import type {MenuListProps} from '@chakra-ui/react';
import {MenuList} from '@chakra-ui/react';
import type {FC} from 'react';

import {useContextMenuStyleConfig} from '../../theme-config';
import {Label} from '../Label';

type Props = {
  title?: string;
} & MenuListProps;

const ContextMenuList: FC<Props> = props => {
  const {children, title, sx, ...rest} = props;
  const style = useContextMenuStyleConfig(`list`, props);
  return (
    <MenuList {...rest} sx={{...style, ...sx}}>
      {title && (
        <Label size={`md`} px={`space-100`} pt={`space-100`}>
          {title}
        </Label>
      )}
      {children}
    </MenuList>
  );
};

export default ContextMenuList;
export type {Props as ContextMenuListProps};
